<template lang="pug">
  v-container#register.fill-height.justify-center(tag="section" fluid).register-container
    v-dialog(v-model='termsDialog' width="600" hide-overlay transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        terms(light style="z-index:999;" @close="termsDialog = false" :openTab="openTab" :inDialog="true").hide-scroll
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' top :timeout='snackbar.timeout')
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-row(justify="center").adaptcontainer
      v-col(cols="12" md="6")
        v-slide-y-transition(appear="")
          v-card.login-card.pa-3.pa-md-5.mx-auto(light="" elevation="12")
            img(:src='logo').register__logo
            v-btn(v-show='$route.name !== "Register"' fab small color="secondary__blue" @click="$emit('close')" style="position: absolute; z-index: 999; top: -10px; right: -10px;")
              v-icon.rounded mdi-close
            pages-heading.text-center.display-3
              | Registro
            .text-center.grey--text.body-1.font-weight-light
              | Regístrate con tus redes sociales
            v-row(style='display:flex; justify-content:center;').text-center.mt-3
              v-btn.mx-2(fab="" dark="" small="" color="cyan" @click="loginProvider('google')")
                v-icon(dark="") mdi-google
              v-btn.mx-2(fab="" dark="" small="" color="cyan" @click="loginProvider('facebook')")
                v-icon(dark="") mdi-facebook
            v-row.register__form
              v-col(cols="12" md="6").hidden-xs-only
                v-row(no-gutters="")
                  v-col(v-for="(section, i) in sections" :key="i" cols="12")
                    v-list-item(three-line="")
                      v-list-item-icon.mr-4.mt-5.mt-md-4
                        v-icon(:large="$vuetify.breakpoint.mdAndUp" :color="section.iconColor" v-text="section.icon")
                      v-list-item-content
                        v-list-item-title.font-weight-light.mb-4.mt-3(v-text="section.title")
                        v-list-item-subtitle(v-text="section.text")
              v-col(cols="12" md="6")
                .text-center
                  .my-2
                    .text-center.grey--text.body-1.font-weight-light
                      | Introduce tus datos
                    v-form(ref="form" v-model="valid")
                      v-text-field(color="secondary" v-model="account.userName" label="Nombre" prepend-icon="mdi-account")
                      v-text-field(v-model="account.email" color="secondary" label="Correo electrónico" :rules="rules.emailRules" type="email" prepend-icon="mdi-email")
                      v-select(v-model="account.country" :items="countries" label="Pais" :rules="rules.countryRules" prepend-icon="mdi-map")
                      v-text-field(v-model="account.password" color="secondary" label="Contraseña" :rules="rules.passwordRules" type="password" prepend-icon="mdi-lock-outline")
                      v-text-field(v-model="account.repeatPassword" color="secondary" label="Verifica tu contraseña" :rules="rules.passwordRepeatRules" type="password" prepend-icon="mdi-lock-outline")
                      v-checkbox(:input-value="false" color="secondary" :rules="rules.termsRules")
                        template(v-slot:label="")
                          span.mx-1 {{$t('terms')}}
                            span(v-for="(item, index) in policies")
                              a.cyan--text.text--darken-3.pl-1(v-if="item.type === 'Interes'" href="#" @click="openTerms(item, index)") {{item.title}}
                    v-btn(small color="primary" @click="validate" :loading="isLoading")
                      | Registrarse
                    v-divider.my-2
                    #firebaseui-auth-container.d-none
                    a(v-if='userType === "business"' href="#/pages/login").display-1 Ya tienes una cuenta?, Ingresa
                    a(v-else @click="$emit('switchDialog')").display-1 Ya tienes una cuenta?, Ingresa
</template>

<script>
  import logo from '@/assets/logo-2.png'
  import terms from '@/components/custom/dialogs/Terms'
  import firebase from 'firebase'
  import 'firebaseui/dist/firebaseui.css'
  import { countries } from '@/locales/countries.json'
  const firebaseui = require('firebaseui')
  var geocoding = require('reverse-geocoding-google')
  var googleKey = 'AIzaSyDKCNiiLsmKRGo9E6UueE9sdZZArHJMJRU' // 'AIzaSyBS6_4xgnglXNo-pxeAJfmgOoGl3ZgdqGo'

  export default {
    name: 'PagesRegister',
    components: {
      PagesBtn: () => import('./components/Btn'),
      PagesHeading: () => import('./components/Heading'),
      terms: terms,
    },
    props: {
      userType: {
        type: String,
        default: function () {
          return 'business'
        },
      },
      referralCode: {
        type: String,
        default: 'none',
      },
    },
    data: () => ({
      openTab: 0,
      countries: countries,
      validLink: false,
      logo: logo,
      errMsg: '',
      valid: true,
      loading: false,
      termsDialog: false,
      account: {
        email: '',
        password: '',
        repeatPassword: '',
        userName: '',
      },
      snackbar: {
        color: '',
        snackbar: false,
        text: '',
        timeout: 6000,
      },
      sections: [
        {
          icon: 'mdi-access-point',
          iconColor: 'primary',
          title: 'Olvídate de los papelitos!',
          text: 'Vende, registra transacciones y factura en tus puntos de venta, recibe ordenes',
        },
        {
          icon: 'mdi-finance',
          iconColor: 'secondary',
          title: 'Vuelvete Digital!',
          text: 'Administra tu tienda en linea y recibe pedidos',
        },
        {
          icon: 'mdi-account-multiple-plus',
          iconColor: 'cyan',
          title: 'Controla tu negocio!',
          text: 'Crea, gestiona y observa la productividad de tus colaboradores en cada uno de tus puntos de venta.',
        },
      ],
    }),
    computed: {
      isLoading () {
        return this.$store.state.users.isLoading
      },
      rules () {
        return {
          emailRules: [
            v => !!v || 'Email es requerido',
            v => /.+@.+\..+/.test(v) || 'El email debe ser valido',
          ],
          passwordRules: [
            v => !!v || 'Contraseña requerido',
            v => (v && v.length >= 8) || 'la contraseña debe tener minimo 8 caracteres',
          ],
          passwordRepeatRules: [
            v => !!v || 'Campo requerido',
            v => (v && v.length >= 8) || 'la contraseña debe tener minimo 8 caracteres',
            v => (v && v === this.account.password) || 'las contraseñas deben coincidir',
          ],
          termsRules: [
            v => !!v || 'Campo requerido',
          ],
          countryRules: [
            v => !!v || 'Pais es requerido',
          ],
        }
      },
      isAuth () {
        return !!this.$store.state.users.user
      },
      policies () {
        return this.$store.getters['cms/getStatic']
      },
    },
    created () {
      const vm = this
      vm.geolocate()
      if (vm.referralCode !== 'none') {
        vm.$store.commit('users/SET_LOADING', true)
        const referralObj = {
          userId: null,
          referralCode: vm.referralCode.toUpperCase(),
          action: 'add',
          subaction: 'validate',
        }
        vm.$store.dispatch('referrals/codeValidator', referralObj).then(res => {
          if (res) {
            vm.validLink = true
            vm.$store.commit('users/SET_LOADING', false)
            vm.errMsg = 'Link verificado ya puedes registrarte.'
            vm.setDataNotification(true, 'info', vm.errMsg)
          } else {
            vm.validLink = false
            vm.$store.commit('users/SET_LOADING', false)
            vm.errMsg = 'Error este link de referido no se encuentra activo.'
            vm.setDataNotification(true, 'error', vm.errMsg)
          }
        })
      }
    },
    mounted () {
      const vm = this
      const uiConfig = {
        signInFlow: 'popup',
        signInSuccessUrl: vm.userType === 'business' ? '#/dashboard/' : '#/',
        signInOptions: [
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        ],
        callbacks: {
          signInSuccessWithAuthResult: function (authResult, redirectUrl) {
            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            // console.log('exitoso')
            vm.$emit('close')
            return true
          },
        },
      }
      let ui = firebaseui.auth.AuthUI.getInstance()
      if (!ui) {
        ui = new firebaseui.auth.AuthUI(firebase.auth())
      }
      ui.start('#firebaseui-auth-container', uiConfig)
      // const ui = new firebaseui.auth.AuthUI(firebase.auth())
    },

    methods: {
      loginProvider (provider) {
        switch (provider) {
          case 'facebook':
            document.getElementsByClassName('firebaseui-idp-facebook')[0].click()
            break
          case 'google':
            document.getElementsByClassName('firebaseui-idp-google')[0].click()
            break
        }
      },
      geolocate () {
        // const vm = this
        navigator.geolocation.getCurrentPosition(position => {
          // gmapApi.geocoder.geo
          const config = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            key: googleKey,
          }
          geocoding.location(config, (err, data) => {
            if (err) {
              console.error(err)
            } else {
              // console.log(data)
              // this.txtAddress = data.results[0].formatted_address
            }
          })
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.register()
        }
      },
      async register () {
        const vm = this
        const path = vm.userType === 'business' ? '/dashboard' : ''
        vm.loading = true
        vm.$store.dispatch('users/register', vm.account)
          .then(async (res) => {
            // console.log(res)
            await vm.$store.dispatch('users/login', vm.account).then((res) => {
              vm.loading = false
              vm.$router.replace(path)
              vm.$emit('close')
              // console.log(vm.referralCode)
              if (vm.referralCode !== 'none' && vm.validLink) {
                setTimeout(() => {
                  const referralObj = {
                    userId: vm.$store.state.users.user.uid,
                    referralCode: vm.referralCode.toUpperCase(),
                    action: 'add',
                    subaction: 'none',
                  }
                  vm.$store.dispatch('referrals/codeValidator', referralObj).then(res => {
                    vm.$store.commit('referrals/SET_REFERRAL_OWNERCODE', vm.referralCode.toUpperCase())
                  })
                }, 10000)
              }
            })
          }).catch(error => {
            // console.log(error)
            vm.errMsg = error.code
            vm.loading = false
            vm.errMsg = 'Email se encuentra en uso'
            this.setDataNotification(true, 'error', vm.errMsg)
          })
      },
      openTerms (item, index) {
        // console.log(index)
        const vm = this
        vm.$store.dispatch('cms/getItem', { context: 'static', id: item.id }).then(function () {
          vm.openTab = index
          vm.termsDialog = true
        })
      },
    },
  }
</script>

<style lang="scss">
  .adaptcontainer{
        max-height: 90vh;
        overflow-y: auto;
        padding-bottom: 3rem;
  }
  .register__logo{
    max-height: 20px;
    border-radius: 0;
    border-top-left-radius: initial !important;
    border-top-right-radius: initial !important;
  }
  .login-card{
    border-radius: 25px !important;
  }
  .register__form {
      display: flex;
      flex-direction: column-reverse;
    @media (min-width: 600px) {
      flex-direction: row;

    }
  }
  .register-container{
    padding-left: 0 !important;
    padding-right: 0 !important;
    @media (max-width: 600px) {
      padding: 0 10px !important
    }
  }
  #register{
    .v-list-item__subtitle{
      -webkic-line-clamp: initial;
      -webkit-box-orient: initial;
    }
  }
</style>
